/**
 * Open Quick Add Action
 * Dispatches a quickadd:open event to trigger external quick add drawer/modal
 * Payload: { product } — the full product object from the tile context
 */

export const runOpenQuickAdd = async (data = {}) => {
  const { product } = data;

  if (!product) {
    throw new Error('runOpenQuickAdd: product is required');
  }

  window.dispatchEvent(new CustomEvent('quickadd:open', {
    detail: { product },
    bubbles: true
  }));

  return { success: true, product };
};

export default runOpenQuickAdd;
